import exclamationIcon from './assets/exclamation-mark.svg';

const DEFAULT_DURATION = 3000;
const DEFAULT_POSITION = 'top-center';

let toasts = [];
let listeners = new Set();
let nextId = 1;

const emit = () => {
    listeners.forEach((listener) => listener(toasts));
};

/**
 * Subscribe to toast list changes.
 * @param {(toasts: Array) => void} listener
 * @returns {() => void} unsubscribe
 */
export const subscribeToasts = (listener) => {
    listeners.add(listener);
    listener(toasts);
    return () => listeners.delete(listener);
};

/**
 * Show a toast notification.
 * @param {{ message: string, variant?: 'warning' | 'success' | 'error', duration?: number, position?: string, icon?: string | null }} options
 * @returns {number} toast id
 */
export const showToast = ({
    message,
    variant = 'warning',
    duration = DEFAULT_DURATION,
    position = DEFAULT_POSITION,
    icon,
} = {}) => {
    const id = nextId++;
    const resolvedIcon =
        icon === null
            ? null
            : icon ||
              (variant === 'warning' || variant === 'error'
                  ? exclamationIcon
                  : null);

    const toast = {
        id,
        message,
        variant,
        duration,
        position,
        icon: resolvedIcon,
    };

    toasts = [...toasts, toast];
    emit();

    if (duration > 0) {
        setTimeout(() => dismissToast(id), duration);
    }

    return id;
};

export const showWarningToast = (message, options = {}) =>
    showToast({ ...options, message, variant: 'warning' });

export const showSuccessToast = (message, options = {}) =>
    showToast({ ...options, message, variant: 'success' });

export const showErrorToast = (message, options = {}) =>
    showToast({ ...options, message, variant: 'error' });

export const dismissToast = (id) => {
    toasts = toasts.filter((toast) => toast.id !== id);
    emit();
};
